module.exports = __webpack_public_path__ + "img/stationery.f0972cc2.jpg";